import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import BeforeAfter from "@/components/site/BeforeAfter";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BeforeAfter />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
